export class ErrorForEndUser extends Error {
  constructor(msg: string) {
    super(msg);

    // Set the prototype explicitly.
    Object.setPrototypeOf(this, ErrorForEndUser.prototype);
  }
}
